import type { SidebarData } from '~layouts/Sidebar/SidebarTypes';

export const ROUTES = {
  ROOT: '/',
  ERROR: '/404',
  LOGIN: '/login',
  PLATFORM: '/platform',
  HOME: '/platform/home',
  REDIRECT: '/redirect',
  RESULTS_LOGIN: '/platform/results_login',
  RESULT_PATIENT: '/platform/results_patient',
  RESULTS_HISTORY: '/platform/results_history',

  COHORT: '/platform/cohort',
  CREATE_LIST: '/platform/create_list',
  FILE_HISTORY: '/platform/file_history',
  FILE_LOAD: '/platform/file_load',
  GROUPS_MANAGEMENT: '/platform/groups_management',
  LOCATION_WITH_PATIENTS: '/platform/location_with_patients',
  MANAGE_COLSUBSIDIO_PATIENTS: '/platform/col_manage_patients',
  MANAGE_PATIENTS: '/platform/manage_patients',
  OBSERVATION_ZONE: '/platform/observation_zone',
  ORDER_ASSIGNMENT: '/platform/order_assignment',
  ORDERS_ASSIGNED: '/platform/orders_assigned',
  PATIENT_LIST: '/platform/patient_list',
  COHORT_V2: '/platform/cohort_v2',
  SCHEDULE_MANAGE: '/platform/schedule_manage',
  SPECIALTY: '/platform/specialty',
  USER_CREATE: '/platform/user_create',
  USER_PROFILE: '/platform/user_profile',
  USER_UPDATE: '/platform/user_update',
  USERS: '/platform/users',
  WORK_LIST: '/platform/work_list',
  WORK_UNITS: '/platform/work_units',
  WORK_UNIT: '/platform/work_unit'
};

export { default as PrivateRoute } from './PrivateRoute';
export { default as PublicRoute } from './PublicRoute';

const privateRouteItemHandler = (item: SidebarData) => {
  if (item.children.length === 0) return item;
  else {
    const childs: SidebarData[] = item.children
      .map((child) => privateRouteItemHandler(child))
      .flat();
    return childs;
  }
};

export const privateRouteOptions = (data: SidebarData[] = []) => {
  return data
    .map((item) => {
      if (item.children.length === 0) return item;
      else
        return item.children
          .map((child) => privateRouteItemHandler(child))
          .flat();
    })
    .flat();
};
